import { useState } from "react";
import { makeEvent, useEventListener } from "services/events";

export type ModalOpener<T = any> = (params?: T) => void;

export function useModalControls<T = any>(
  eventName: string,
  options?: {
    onOpen?: (params?: T) => void;
    onClose?: () => void;
    initialIsOpen?: boolean;
  }
) {
  const [isOpen, setIsOpen] = useState(options?.initialIsOpen ?? false);
  const [params, setParams] = useState<Partial<T>>({});

  const onOpen = (params?: T) => {
    setParams(params ?? {});
    setIsOpen(true);
    options?.onOpen?.(params);
  };

  const onClose = () => {
    setIsOpen(false);
    setParams({});
    options?.onClose?.();
  };

  useEventListener(eventName, onOpen);

  return { onClose, onOpen, isOpen, params };
}

export function createModalTrigger<T = any>(eventName: string): ModalOpener<T> {
  return (params) => makeEvent(eventName, params);
}
